import { defineComponent as _defineComponent } from 'vue'
import {
  ref,
  onMounted,
  onUnmounted,
  PropType,
  watch,
  nextTick
} from 'vue';
import Icon from '@/components/IllinoisSport/components/icons.vue';
import { GenericOption } from '../../../../types/components';

interface DropdownItem {
  label: string;
  value: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownSelector',
  props: {
  title: {
    type: String,
    default: 'Seleziona'
  },
  items: {
    type: Array as PropType<DropdownItem[]>,
    default: () => []
  },
  modelValue: {
    type: [String, Number, Object],
    default: null
  },
  selectedItem: {
    type: Object as PropType<GenericOption>,
    default: () => ({
      label: '',
      value: ''
    })
  },
  isCentered: {
    type: Boolean,
    default: true
  }
},
  emits: ['update:modelValue', 'change'],
  setup(__props, { emit }) {

const props = __props;





const isOpen = ref(false);
const dropdownRef = ref<HTMLElement | null>(null);
const dropdownPosition = ref<'top' | 'bottom'>('bottom');
const dropdownContent = ref<HTMLElement | null>(null);
const dropdownWrapper = ref<HTMLElement | null>(null);
const wrapperStyles = ref<Record<string, string>>({});
let windowChangeRafId: number | null = null;

function toggleDropdown() {
  isOpen.value = !isOpen.value;

  if (isOpen.value) {
    // Calcoliamo la posizione del dropdown al momento dell'apertura
    calculateDropdownPosition();
    /* nextTick(() => {
      adjustDropdownWithinViewport();
    }); */
  }
}

function calculateDropdownPosition() {
  if (!dropdownRef.value) return;

  // Otteniamo le dimensioni e posizioni degli elementi
  const headerRect = dropdownRef.value.getBoundingClientRect();
  const dropdownHeight = 250; // Altezza stimata del dropdown (può essere migliorata)
  const windowHeight = window.innerHeight;
  const spaceBelow = windowHeight - headerRect.bottom;

  // Se lo spazio sotto è insufficiente ma c'è spazio sopra, mostriamo il dropdown sopra
  if (spaceBelow < dropdownHeight && headerRect.top > dropdownHeight) {
    dropdownPosition.value = 'top';
  } else {
    dropdownPosition.value = 'bottom';
  }
}

function adjustDropdownWithinViewport() {
  if (!dropdownRef.value || !dropdownWrapper.value) return;

  const headerRect = dropdownRef.value.getBoundingClientRect();
  const wrapperRect = dropdownWrapper.value.getBoundingClientRect();

  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;

  const horizontalPadding = 8; // margine minimo dal bordo

  const wrapperWidth =
    wrapperRect.width || dropdownWrapper.value.offsetWidth || 256;
  const wrapperHeight =
    wrapperRect.height || dropdownWrapper.value.offsetHeight || 250;

  // Centro orizzontale rispetto al trigger
  const desiredCenterX = headerRect.left + headerRect.width / 2;
  let left = desiredCenterX - wrapperWidth / 2;

  // Clamping orizzontale per rimanere nel viewport
  const minLeft = horizontalPadding;
  const maxLeft = Math.max(
    minLeft,
    viewportWidth - wrapperWidth - horizontalPadding
  );
  if (left < minLeft) left = minLeft;
  if (left > maxLeft) left = maxLeft;

  // Posizionamento verticale
  const verticalGap = 8; // spazio tra trigger e menu
  let top: number | undefined;
  let bottom: number | undefined;

  if (dropdownPosition.value === 'bottom') {
    top = Math.min(
      Math.max(0, headerRect.bottom + verticalGap),
      Math.max(0, viewportHeight - wrapperHeight - verticalGap)
    );
    bottom = undefined;
  } else {
    // sopra il trigger
    const candidateTop = headerRect.top - wrapperHeight - verticalGap;
    top = Math.max(
      0,
      Math.min(candidateTop, viewportHeight - wrapperHeight - verticalGap)
    );
    bottom = undefined;
  }

  const style: Record<string, string> = {
    left: `${left}px`,
    zIndex: '9999'
  };

  if (typeof top === 'number') {
    style.top = `${top}px`;
    style.bottom = 'auto';
  } else if (typeof bottom === 'number') {
    style.bottom = `${bottom}px`;
    style.top = 'auto';
  }

  wrapperStyles.value = style;
}

function selectItem(item: any) {
  emit('update:modelValue', item);
  emit('change', item);
  isOpen.value = false;
}

function handleClickOutside(event: Event) {
  const dropdownContainer = dropdownRef.value;
  if (dropdownContainer && !dropdownContainer.contains(event.target as Node)) {
    isOpen.value = false;
  }
}

// Gestione click outside
onMounted(() => {
  document.addEventListener('click', handleClickOutside);
  window.addEventListener('resize', onWindowChange, { passive: true });
  window.addEventListener('scroll', onWindowChange, { passive: true });
});

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
  window.removeEventListener('resize', onWindowChange);
  window.removeEventListener('scroll', onWindowChange);
  if (windowChangeRafId !== null) {
    cancelAnimationFrame(windowChangeRafId);
    windowChangeRafId = null;
  }
});

watch(isOpen, () => {
  if (isOpen.value) {
    /* nextTick(() => {
      calculateDropdownPosition();
      adjustDropdownWithinViewport();
    }); */
  } else {
    wrapperStyles.value = {};
  }
});

function onWindowChange() {
  if (!isOpen.value) return;
  if (windowChangeRafId !== null) return;
  windowChangeRafId = requestAnimationFrame(() => {
    windowChangeRafId = null;
    calculateDropdownPosition();
    /*  adjustDropdownWithinViewport(); */
  });
}

return { __sfc: true,props, emit, isOpen, dropdownRef, dropdownPosition, dropdownContent, dropdownWrapper, wrapperStyles, windowChangeRafId, toggleDropdown, calculateDropdownPosition, adjustDropdownWithinViewport, selectItem, handleClickOutside, onWindowChange, Icon }
}

})